// Plan catalog and checkout entry - browsing plans and joining one, before a subscription exists yet.
import { postData, getData } from '../plugins/ApiCalls'

// Get all available plans
export function getPlans() {
  return getData('plans')
}

// Checks whether the user already has a subscription matching this plan.
export function getSubscriptionForPlan(planId) {
  return getData('plans/' + planId + '/subscription')
}

// Imports a completed Paddle Billing checkout into the API using the selected plan.
export function syncPlanSubscription(publicId, token = null) {
  const config = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {}

  return postData('plans/sync-subscription', { public_id: publicId }, config)
}
